var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPersonSearch(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5858_35562)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5 6C6.10457 6 7 5.10457 7 4C7 2.89543 6.10457 2 5 2C3.89543 2 3 2.89543 3 4C3 5.10457 3.89543 6 5 6Z",
    fill: "#303F47"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.175 7.00452C3.81 6.95452 1 7.63452 1 8.99952V9.49952C1 9.77452 1.225 9.99952 1.5 9.99952H5.77C4.535 8.61952 5.155 7.05452 5.175 7.00452Z",
    fill: "#303F47"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.71506 9.01026C9.95006 8.61026 10.0651 8.12526 9.95506 7.60026C9.78506 6.78026 9.09506 6.12526 8.26506 6.02026C6.95006 5.85026 5.84006 6.95526 6.01506 8.27026C6.12506 9.10026 6.77506 9.79026 7.59506 9.96026C8.12006 10.0703 8.60506 9.95526 9.00506 9.72026L9.93506 10.6503C10.1301 10.8453 10.4451 10.8453 10.6401 10.6503C10.8351 10.4553 10.8351 10.1403 10.6401 9.94526L9.71506 9.01026ZM8.00006 9.00026C7.45006 9.00026 7.00006 8.55026 7.00006 8.00026C7.00006 7.45026 7.45006 7.00026 8.00006 7.00026C8.55006 7.00026 9.00006 7.45026 9.00006 8.00026C9.00006 8.55026 8.55006 9.00026 8.00006 9.00026Z",
    fill: "#303F47"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5858_35562"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 12,
    height: 12,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPersonSearch);
export default __webpack_public_path__ + "static/media/person-search.c54a181c0e95d6a53aa50bb4fee805c2.svg";
export { ForwardRef as ReactComponent };